import React from 'react';
import styled from 'styled-components';

const IssueRequest = styled.svg`
	width: 56px;
	height: 56px;
	position: relative;
	.cls-1 {
		fill: #a2a9ad;
	}
	.cls-2 {
		fill: #a2a9ad;
	}
	.cls-3 {
		isolation: isolate;
	}
	.cls-4 {
		fill: none;
	}
	&.medium {
		width: 80px;
		height: 80px;
	}
	&.large {
		width: 136px;
		height: 136px;
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		svg {
			width: 80px !important;
			height: 80px !important;
		}
	}

	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 136px;
		height: 136px;
	}
`;

export const ShippingSVG = ({ className, id }) => {
	return (
		<IssueRequest
			xmlns='http://www.w3.org/2000/svg'
			width='126'
			height='128.023'
			viewBox='0 0 470 470'
			id={id}
			className={className}
		>
			<defs>
				<linearGradient
					id={`${id}-linear-gradient-cog`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(35)'
				>
					<stop offset='0' stop-color='#79d2de'>
						<animate
							id={`${id}trans1`}
							dur='1s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#a2a9ad'>
						<animate
							id={`${id}trans1`}
							dur='1s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
				<linearGradient
					id={`${id}-linear-gradient-cog-2`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(35)'
				>
					<stop offset='0' stop-color='#79d2de'>
						<animate
							id={`${id}trans3`}
							dur='0.5s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#edefef'>
						<animate
							id={`${id}trans3`}
							dur='0.5s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
				<linearGradient
					id={`${id}-swipe-gradient`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(35)'
				>
					<stop offset='0' stop-color='#edefef'>
						<animate
							id={`${id}trans2`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#79d2de'>
						<animate
							id={`${id}trans2`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
			</defs>
			<g id='Layer_2' class='cls-4' data-name='Layer 2'>
				<g id='ARTWORK' class='cls-4'>
					<g id='shipping-primary'>
						<path id='boundary' class='cls-4' d='M0,0H470V470H0Z' />
						<g id='shipping-primary-2' class='cls-4' data-name='shipping-primary'>
							<path
								class='cls-1'
								id={id}
								d='M452,333V299.22L361,182H301V315H35v44H86a49,49,0,0,0,49,49h.08A48.9,48.9,0,0,0,184,359s136-.06,136,0a49,49,0,0,0,49,49c27,0,49.5-22,49.5-49H470V333ZM135.08,381.81A21.91,21.91,0,1,1,157,359.9,21.91,21.91,0,0,1,135.08,381.81ZM328,250a7,7,0,0,1-7-7V209a7,7,0,0,1,7-7h15.25c4.22,0,5.25,1.73,7.51,4.51L386,250Zm45.68,131.4a21.91,21.91,0,1,1,0-43,22,22,0,0,1,0,43Z'
							/>
							<polygon
								id='side'
								class='cls-1'
								points='285 108 184 108 184 184 101 184 101 108 0 108 0 299 285 299 285 108'
							/>
							<polygon
								id='top-right'
								class='cls-1'
								points='284.63 92 236 61 163 61 177 92 284.63 92'
							/>
							<polygon
								id='top-left'
								class='cls-1'
								points='121.63 61 48.63 61 0 92 107.63 92 121.63 61'
							/>
						</g>
					</g>
				</g>
			</g>
		</IssueRequest>
	);
};
